<div class="position-relative">
  <div class="main-container input position-relative" (click)="toggleDropdown($event)" style="cursor: pointer;">
    <p class="value mb-0">{{ findUserById(selectedCustomerId) || 'Select User' }}</p>
  </div>
  <!-- Dropdown list -->
  <div class="abs-container" *ngIf="isDropdownVisible" (click)="$event.stopPropagation()">
    <div class="list-main-container">
      <div class="search-container">
        <input type="text" class="search-input" placeholder="Search..." [(ngModel)]="searchQuery"
          (input)="filterCountries()" autofocus />
      </div>
      <div class="list-container">
        <div class="list-item" *ngFor="let user of filterSearchResults" (click)="selectUser(user)">
          <p class="name">{{ formatDisplayName(user) }}</p>
        </div>
        <div class="no-results list-item" *ngIf="filterSearchResults.length === 0">
          <p class="name">No results found</p>
      </div>
    </div>
  </div>
</div>